import React from "react";
import './image_info.css'


const ImageInfo = ({ imageUrl, lines }) => {
    return (
        <div className="image_info">
            <img src={imageUrl} alt="Location" />

            <div className="image_info__text">
                {lines.map((line, index) => (
                    <span key={index}>
                        {line}
                    </span>
                ))}
            </div>
            
        </div>
    );
};


export default ImageInfo;
